export default __webpack_public_path__ + "static/media/pencil.38cac211.svg";